import { combineReducers } from 'redux'
import { duck as homeDuck } from '@/store/home'
import { duck as cartDuck } from '@/store/cart'
import { duck as detailDuck } from '@/store/detail'
// import { duck as commentDuck } from '@/store/comment'
import { duck as addonDuck } from '@/store/addon'
import { duck as commonDuck } from '@/store/common'
import { duck as couponDuck } from '@/store/coupon'
import { duck as newlyDuck } from '@/store/newly'
import { duck as double11Duck } from '@/store/double11'
import { duck as confirmDuck } from '@/store/confirm'
import { duck as addressDuck } from '@/store/address'
import { duck as newAddressDuck } from '@/store/newAddress'
import { duck as discountDuck } from '@/store/discount'
import { duck as evaluateDuck } from '@/store/evaluate'
import { duck as ordersDuck } from '@/store/orders'
import { duck as orderDetailDuck } from '@/store/orderDetail'
import { duck as wishComDuck } from '@/store/wishCom'
import { duck as wishGoodsDuck } from '@/store/wishGoods'
import { duck as wishCartDuck } from '@/store/wishCart'

export const rootReducer = combineReducers({
  ['homeDuck']: homeDuck.reducer,
  ['cartDuck']: cartDuck.reducer,
  ['detailDuck']: detailDuck.reducer,
  ['addonDuck']: addonDuck.reducer,
  ['commonDuck']: commonDuck.reducer,
  ['couponDuck']: couponDuck.reducer,
  ['newlyDuck']: newlyDuck.reducer,
  ['double11Duck']: double11Duck.reducer,
  ['confirmDuck']: confirmDuck.reducer,
  ['addressDuck']: addressDuck.reducer,
  ['newAddressDuck']: newAddressDuck.reducer,
  ['discountDuck']: discountDuck.reducer,
  ['evaluateDuck']: evaluateDuck.reducer,
  ['ordersDuck']: ordersDuck.reducer,
  ['orderDetailDuck']: orderDetailDuck.reducer,
  ['wishComDuck']: wishComDuck.reducer,
  ['wishGoodsDuck']: wishGoodsDuck.reducer,
  ['wishCartDuck']: wishCartDuck.reducer,
})
